export var log = function log(message, level) {
  if (level === void 0) {
    level = 'warn';
  }
  if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console[level](message);
  }
};
export var logDeprecation = function logDeprecation(message) {
  log("[Deprecation] " + message);
};